import { useQuery } from "@tanstack/react-query";
import { getKeyEventsDetail } from "../service";

export const useKeyEventsDetail = () => {
  return useQuery({
    key: "keyEventsDetail",
    queryKey: ["keyEventsDetail"],
    queryFn: () => getKeyEventsDetail(),
  });
};
